import type { StatsSnapshot } from '../../../stats/gameplay-snapshot';
import { CharacterClass, type GameGenerators } from '../../../types/game-types';
import { shuffleArray } from '@game-libs/exc-libs/src/helpers';
import { unitStats } from '../../../stats';

export const clericReducer = (scratch: StatsSnapshot) => {
  const typesToGenerate: (keyof GameGenerators)[] = [];
  if (scratch.upgrades.cleric.recruitWarriors.multiplier > 0) {
    typesToGenerate.push(CharacterClass.Warrior);
  }
  if (scratch.upgrades.cleric.recruitWizards.multiplier > 0) {
    typesToGenerate.push(CharacterClass.Wizard);
  }
  if (scratch.upgrades.cleric.recruitElves.multiplier > 0) {
    typesToGenerate.push(CharacterClass.Elf);
  }
  if (scratch.upgrades.cleric.recruitThieves.multiplier > 0) {
    typesToGenerate.push(CharacterClass.Thief);
  }
  if (scratch.upgrades.cleric.recruitBards.multiplier > 0) {
    typesToGenerate.push(CharacterClass.Bard);
  }
  // if (scratch.upgrades.cleric.recruitClerics.multiplier > 0) {
  //   typesToGenerate.push(CharacterClass.Cleric);
  // }

  const shuffledTypes = shuffleArray<keyof GameGenerators>(typesToGenerate);

  const stats = unitStats.cleric;
  let generatedUnits = stats.unitsGeneration ?? 0;

  // Use critical chance logic to double units if critical check passes
  const isCritical = Math.random() * 100 < (stats.criticalChance ?? 0);

  const generatedAmount = Math.floor(generatedUnits / shuffledTypes.length);
  const generatedRemainder = generatedUnits % shuffledTypes.length;

  shuffledTypes.forEach((type, index) => {
    const multiplier = isCritical ? 2 : 1;

    scratch.generators[type].owned += multiplier * Math.floor(generatedAmount + (index < generatedRemainder ? 1 : 0));
  });

};
